import React, { useState, useEffect } from 'react'
import { Form, Label, Button, Image } from 'semantic-ui-react'
import './Register.scss'
import facebook_color from '../../../assets/facebook_color.svg'
import twitter_color from '../../../assets/twitter_color.svg'
import google from '../../../assets/google.svg'
import { connect } from 'react-redux'
import { signUp, signUpWithSocialMedia } from '../../../redux/actions/auth'
import { withRouter } from 'react-router'

const Register = props => {

    const { uid } = props;

    const [credentials, setCredentials] = useState({
        name: '',
        surname: '',
        email: '',
        password: ''
    });

    useEffect(() => {
        if(uid) {
            props.history.push('/')
        }
    }, [uid])

    const handleOnChange = e => {
        const { name, value } = e.target;
        setCredentials({
            ...credentials,
            [name]: value
        });
    }

    const handleOnSubmit = e => {
        
        e.preventDefault();

        props.signUp(credentials)

    }

    return (
        <div className='register'>
            <div className='content'>
                <Label>Crea tu cuenta</Label>

                <Form onSubmit={handleOnSubmit}> 

                    <Form.Field>
                        <input 
                            placeholder='Nombre' 
                            type='text' 
                            name='name' 
                            autoComplete='off'
                            onChange={handleOnChange} />
                    </Form.Field>
                    <Form.Field>
                        <input 
                            placeholder='Apellidos' 
                            type='text' 
                            name='surname' 
                            autoComplete='off'
                            onChange={handleOnChange} />
                    </Form.Field>
                    <Form.Field>
                        <input 
                            placeholder='Email' 
                            type='email' 
                            name='email' 
                            autoComplete='off'
                            onChange={handleOnChange} />
                    </Form.Field>
                    <Form.Field>
                        <input 
                            placeholder='Contraseña' 
                            type='password' 
                            name='password' 
                            autoComplete='off'
                            onChange={handleOnChange} />
                    </Form.Field>

                    <Button type='submit'>Registrarse</Button>

                    <div className='social'>
                        <div className='or'>
                            <hr/>
                            <label>O regístrate con</label>
                            <hr/>
                        </div>
                        <div className='buttons'>
                            <Image src={facebook_color} onClick={() => props.signUpWithSocialMedia('facebook')} />
                            <Image src={google} onClick={() => props.signUpWithSocialMedia('google')} />
                            <Image src={twitter_color}  onClick={() => props.signUpWithSocialMedia('twitter')}/>
                        </div>
                    </div>
                </Form>
            </div>
        </div>
    )
}

// Redux
const mapStateToProps = state => {

    const uid = state.auth.uid;

    return {
        uid
    }
}

const mapDispatchToProps = dispatch => {
    return {
        signUp: (credentials) => dispatch(signUp(credentials)),
        signUpWithSocialMedia: (idSocialMedia) => dispatch(signUpWithSocialMedia(idSocialMedia))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Register))
